import React from "react";
import {
  FormField,
  FormInput,
  FormSelect,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";
import { COMPONENT_TYPES, SYSTEM_STATUSES } from "../../constants";

export interface AddComponentDialogProps {
  open: boolean;
  onClose: () => void;
  handleAddComponent: () => void;
  addingComponent: boolean;
  componentForm: {
    title: string;
    componentType: string;
    description: string;
    purpose: string;
    status: string;
  };
  setComponentForm: React.Dispatch<
    React.SetStateAction<{
      title: string;
      componentType: string;
      description: string;
      purpose: string;
      status: string;
    }>
  >;
}

export function AddComponentDialog({
  open,
  onClose,
  handleAddComponent,
  addingComponent,
  componentForm,
  setComponentForm,
}: AddComponentDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Add Component"
      description="Add a component to this SSP"
      size="md"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleAddComponent}
          submitLabel={addingComponent ? "Saving" : "Save"}
          submitDisabled={
            !componentForm.title ||
            !componentForm.componentType ||
            addingComponent
          }
        />
      }
    >
      <FormField label="Component Name" required>
        <FormInput
          placeholder="e.g. API Gateway"
          value={componentForm.title}
          onChange={(v) => setComponentForm((f) => ({ ...f, title: v }))}
        />
      </FormField>
      <FormField label="Component Type" required>
        <FormSelect
          options={COMPONENT_TYPES}
          placeholder="Select type"
          value={componentForm.componentType}
          onChange={(v) =>
            setComponentForm((f) => ({
              ...f,
              componentType: v,
            }))
          }
        />
      </FormField>
      <FormField label="Description">
        <FormTextarea
          placeholder="Description of the component"
          value={componentForm.description}
          onChange={(v) =>
            setComponentForm((f) => ({ ...f, description: v }))
          }
          rows={2}
        />
      </FormField>
      <FormField label="Purpose">
        <FormInput
          placeholder="e.g. Entry point for all API traffic"
          value={componentForm.purpose}
          onChange={(v) => setComponentForm((f) => ({ ...f, purpose: v }))}
        />
      </FormField>
      <FormField label="Status">
        <FormSelect
          options={SYSTEM_STATUSES}
          placeholder="Select status"
          value={componentForm.status || ""}
          onChange={(v) =>
            setComponentForm((f) => ({
              ...f,
              status: v.toLowerCase(),
            }))
          }
        />
      </FormField>
    </Modal>
  );
}
